import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import 'swiper/css';
import './src/styles/global.css';


const syncHeaderScrollClass = () => {
    const header = document.getElementById("headerMenu");
    if (!header) return;
    if (window.scrollY > 100) {
        header.classList.add("headerScrollAnimation");
    } else {
        header.classList.remove("headerScrollAnimation");
    }
};

export const onInitialClientRender = () => {
    syncHeaderScrollClass();
    window.addEventListener("scroll", syncHeaderScrollClass, { passive: true });
};

// Wraps every page in a component
export const wrapPageElement = ({ element }) => {
    return <div>{element}</div>;
};
